import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ConfirmProvider } from "@/components/ui/confirm";
import { Toaster } from "@/components/ui/toaster";
import { DensityProvider } from "@/modules/shell/density";
import { QueryProvider } from "@/shared/query/QueryProvider";
import { App } from "./app/App";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

/** Match Vite `base` for /v/{version}/ snapshots — plan/08 */
const basename = import.meta.env.BASE_URL.replace(/\/$/, "") || undefined;

createRoot(root).render(
  <StrictMode>
    <QueryProvider>
      <DensityProvider>
        <BrowserRouter basename={basename}>
          <ConfirmProvider>
            <App />
            <Toaster />
          </ConfirmProvider>
        </BrowserRouter>
      </DensityProvider>
    </QueryProvider>
  </StrictMode>,
);
